import React, { useEffect, useState, useRef } from "react";
import SchoolHeader from "../HospitalHeader";
import Footer from "../Footer"
import SschoolHeader from "../SchoolHeader";
import { Row, Col, Card, Form, Container, Button } from "react-bootstrap"
import { FaTrashAlt } from "react-icons/fa";
import { AiOutlineEdit } from "react-icons/ai";
import { authServices } from "../../services/auth.services";
import { DataGrid } from "@mui/x-data-grid"
import LoadingBar from "./toaster/loader/loader";
import { useParams } from "react-router-dom";
import hospitalServices from "../../services/hospital.services";
import { MultiSelect } from "react-multi-select-component";
import { showSuccessMessage } from "../../services/utils";
import { showErrorMessage } from "../../services/utils";

const Auth = [
    { label: "Administrative Documents", value: "administrative_docs" },
    { label: "My Files", value: "my_files" },
    { label: "Student Contracts", value: "student_contracts" },
]
const SubAdmin = (props) => {
    const params = useParams()
    const formRef = useRef(null);
    const columns = [
        {
            field: "email",
            headerName: "Email",
            sortable: false,
            width: 185,
        },
        {
            field: "name",
            headerName: "Name",
            sortable: false,
            width: 185,
        },
        {
            field: "phone",
            headerName: "Phone",
            sortable: false,
            width: 185,
        },
        {
            field: "action",
            headerName: "Action",
            sortable: false,
            width: 100,
            renderCell: (params) => {
                return (
                    <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ cursor: "pointer" }}
                    >
                        <span className="actn_icn mr-3">
                            <AiOutlineEdit title="edit" onClick={() => {
                                editSubAdmin(params.row)
                            }} />
                        </span>
                        <span className="actn_icn">
                            <FaTrashAlt title="Delete" onClick={() => {
                                removeSubAdmin(params.rowNode.id)
                            }} />
                        </span>
                    </div>
                );
            },
        },
    ];
    const [select, setSelected] = useState({
        schools: [], showSchool: []
    })
    const [optionList, setoptionList] = useState([])
    const [loading, setloading] = useState(false)
    const [inputData, setInputdata] = useState({ auth_sub_admin_privilege: { privilege_ids: [] } })
    const [mySubAdmins, setSubAdmins] = useState([])
    const [editSub, setEditSub] = useState(false)
    const [editSubId, setEditSubId] = useState(false)

    const addSubAdmin = (e) => {
        e.preventDefault();
        inputData.role = params.role
        inputData.sub_admin_ref_id = params.id
        if (params.who === "Sub-Admin") {
            inputData.is_auth_sub_admin = true
        } else {
            inputData.is_sub_admin = true
        }
        const schoolIds = []
        select.showSchool.map((resp) => {
            schoolIds.push(resp.value)
        })
        const programIds = []
        select.showSchool.map((resp) => {
            programIds.push(resp.value)
        })
        setloading(true)



        if (editSub) {          //__________________check  edit or new create admin________________________
            alert("ist if")
            
            if(params.role === 'school'){ //__________________check  SCHOOL or hosPITAL EDit________________________
                alert("2nd if")
                Object.assign(inputData.auth_sub_admin_privilege, { "privilege_ids": schoolIds });
                inputData.sub_admin_id = editSubId
                authServices.editSchoolSubAdmin(inputData).then(resp => {
                    getList()
                    setloading(false)
                    setEditSub(false)
                    setInputdata({ auth_sub_admin_privilege: { privilege_ids: [] } })
                    setSelected({
                        schools: [], showSchool: []
                    })
                    showSuccessMessage({ message: " School Sub-Admin updated" })
                    formRef.current.reset();
    
                }).catch(err => {
                    if (err.response.data.errors.msg) {
                        showErrorMessage({ message: err.response.data.errors.msg })
                    }
    
                    setloading(false)
                })
            }else{
                

                Object.assign(inputData.auth_sub_admin_privilege, { "privilege_ids": schoolIds });
                inputData.sub_admin_id = editSubId
                authServices.editHospiatalSubAdmin(inputData).then(resp => {
                    getList()
                    setloading(false)
                    setEditSub(false)
                    setInputdata({ auth_sub_admin_privilege: { privilege_ids: [] } })
                    setSelected({
                        schools: [], showSchool: []
                    })
                    showSuccessMessage({ message: " Hopital Sub-Admin updated" })
                    formRef.current.reset();
    
                }).catch(err => {
                    if (err.response.data.errors.msg) {
                        showErrorMessage({ message: err.response.data.errors.msg })
                    }
    
                    setloading(false)
                })
            }
           
        } else {
            Object.assign(inputData.auth_sub_admin_privilege, { "privilege_ids": schoolIds });
            authServices.addSubAdmin(inputData).then(resp => {
                getList()
                setInputdata({ auth_sub_admin_privilege: { privilege_ids: [] } })
                setloading(false)
                setSelected({
                    schools: [], showSchool: []
                })
                showSuccessMessage({ message: "Sub-Admin Added" })
                formRef.current.reset();

            }).catch(err => {
                if (err.response.data.errors.msg) {
                    showErrorMessage({ message: err.response.data.errors.msg })
                }

                setloading(false)
            })
        }



    }

    const handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        setInputdata({
            ...inputData,
            [name]: value
        })
    }

    const editSubAdmin = (data) => {
        setEditSub(true)
        setEditSubId(data._id)
        setInputdata(data)
        let ids = []
        
        if(params.role === 'school'){
          
            data.programData.map(curr => {

                ids.push({ label: curr.program_name, value: curr._id })
            })
            setSelected(prev => ({ ...prev, "showSchool": ids }))
          
        }else{
            
            data.schoolData.map(curr => {

                ids.push({ label: curr.school_name, value: curr._id })
            })
            setSelected(prev => ({ ...prev, "showSchool": ids }))
           

        }
    }
    // _______________________________________get api for subadmin created_____________________________
    const getList = () => {

        if (params.who === "Sub-Admin") {
            authServices.getSubAdminList(params.id, "is_auth_sub_admin").then(resp => {
                setSubAdmins([])
                resp.user.map(curr => {
                    curr.id = curr._id
                    setSubAdmins(oldRow => ([curr, ...oldRow]))
                })
            }).catch(err => {
                setloading(false)
                console.log(err, "<- Err");
            })
        } else {
            authServices.getSubAdminList(params.id, "is_sub_admin").then(resp => {
                setSubAdmins([])
                resp.user.map(curr => {
                    curr.id = curr._id
                    setSubAdmins(oldRow => ([curr, ...oldRow]))
                })
            }).catch(err => {
                setloading(false)
                console.log(err, "<- Err");
            })
        }

    }

    const removeSubAdmin = (data) => {
        setloading(true)
        const sharedata = {
            id: data,
            sub_admin_ref_id: params.id
        }
        authServices.removeOneSubAdmin(sharedata).then(resp => {
            setloading(false)
            showSuccessMessage({ message: "User Removed" })
            getList()
        }).catch(err => {
            setloading(false)
            console.log(err)
        })
    }

    const getSchoolList = () => {
        setoptionList([])
        if (params.role === "school") {
            authServices.getSchoolPro().then(resp => {
             
                resp.data.map(curr => {
                    setoptionList(prevState => ([...prevState,
                    {
                        label: curr.program_name,
                        value: curr._id

                    }]))
                })

            }).catch(err => { console.log(err) })

        } else {
            hospitalServices.getSchoolListSubAdmin(params.id).then(resp => {
                resp.data.data && resp.data.data.length > 0 &&
                    resp.data.data.map(curr => {
                        setoptionList(prevState => ([...prevState,
                        {
                            label: curr.school_name,
                            value: curr._id

                        }]))
                    })
            })
        }



    }

    useEffect(() => {
        getList()
        getSchoolList()
    }, [])


    return (
        <>
            {
                params.role === 'school' ? <SschoolHeader />
                    :
                    <SchoolHeader />
            }
            <div className="schl_prfl_pg">
                {loading && <LoadingBar />}
                <Container className="custm_container">
                    <Row>
                        <Col sm={7}>
                            <Card className="pg_card">
                                <Card.Body>
                                    <div className="card_hdng">
                                        <h4 className="mb-0">
                                            My {params.who}
                                        </h4>
                                    </div>
                                    <div className="apprvl_list">
                                        <div
                                            style={{
                                                height: 400,
                                                width: "100%",
                                            }}
                                        >
                                            <DataGrid
                                                rows={mySubAdmins && mySubAdmins}
                                                columns={columns}
                                                pageSize={5}
                                                rowsPerPageOptions={[5]}
                                            />
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col sm={5}>
                            <Card className="pg_card">
                                <Card.Body className="overAuto">
                                    <div className="card_hdng ">
                                        <h4 className="mb-0">
                                            Add {params.who}
                                        </h4>
                                    </div>
                                    <div className="prfl_flds">
                                        <Form onSubmit={addSubAdmin} ref={formRef} >
                                            <Form.Group
                                                className="mb-3"
                                                controlId="exampleForm.ControlTextarea1"
                                            >
                                                <Form.Label>
                                                    Name{" "}
                                                </Form.Label>
                                                <Form.Control
                                                    required
                                                    name='name'
                                                    type="text"
                                                    value={inputData?.name}
                                                    placeholder="Enter Name of person"
                                                    onChange={handleChange}
                                                />
                                            </Form.Group>
                                            <Form.Group
                                                className="mb-3"
                                                controlId="exampleForm.ControlTextarea1"
                                            >
                                                <Form.Label>
                                                    Email{" "}
                                                </Form.Label>
                                                <Form.Control
                                                    required
                                                    name='email'
                                                    type="email"
                                                    disabled={editSub}
                                                    value={inputData?.email}

                                                    placeholder="Enter Email of person"
                                                    onChange={handleChange}
                                                />
                                            </Form.Group>

                                            <Form.Group
                                                className="mb-3"
                                                controlId="exampleForm.ControlTextarea1"
                                            >
                                                <Form.Label>
                                                    Phone{" "}
                                                </Form.Label>
                                                <Form.Control
                                                    required
                                                    name='phone'
                                                    type="phone"
                                                    value={inputData?.phone}

                                                    placeholder="Enter Phone of person"
                                                    onChange={handleChange}
                                                />
                                            </Form.Group>

                                            {
                                                params.who === 'Sub-Admin' &&
                                                <>
                                                    <Form.Group
                                                        className="mb-3"
                                                        controlId="exampleForm.ControlTextarea1"
                                                    >
                                                        <Form.Label>
                                                           { params.role === "school"?"Select Program":"Select Schools"}
                                                        </Form.Label>
                                                        <MultiSelect
                                                            overrideStrings={{
                                                                "allItemsAreSelected": "All Schools are selected.",
                                                                "noOptions": "No Schools available",
                                                                "search": "Search for Schools",
                                                                "clearSearch": "Clear Search",
                                                                "clearSelected": "Clear Selected",
                                                                "selectAll": "Select All Schools",
                                                                "selectAllFiltered": "Select All (Filtered)",
                                                                "selectSomeItems": "Select Schools",
                                                                "create": "Create",
                                                            }}
                                                            className="multi_slct"
                                                            options={optionList}
                                                            value={select?.showSchool}
                                                            onChange={(e) => {
                                                                setSelected(prev => ({ ...prev, "showSchool": e }))

                                                            }}
                                                            labelledBy="Select"
                                                        />
                                                    </Form.Group>
                                                    <Form.Group
                                                        className="mb-3"
                                                        controlId="exampleForm.ControlTextarea1"
                                                    >

                                                        {
                                                            Auth.map(curr => {
                                                                return (
                                                                    <div style={{ fontSize: "18px", height: "60px" }}>
                                                                        <Form.Label>
                                                                            {curr.label + ":"}
                                                                        </Form.Label>
                                                                        <div>
                                                                            <Form.Check
                                                                                inline
                                                                                label="Yes"
                                                                                type="radio"
                                                                                name={curr.value}
                                                                                value={"true"}
                                                                                // required={!Fieldval.covid_vaccinated && true}
                                                                                onChange={(e) => {
                                                                                    setInputdata({ ...inputData, auth_sub_admin_privilege: { ...inputData.auth_sub_admin_privilege, [e.target.name]: e.target.value } })
                                                                                }}
                                                                                checked={inputData && inputData?.auth_sub_admin_privilege && inputData?.auth_sub_admin_privilege[curr.value] === "true"}
                                                                                id="o17"
                                                                            />

                                                                            <Form.Check
                                                                                inline
                                                                                label="No"
                                                                                type="radio"
                                                                                name={curr.value}
                                                                                value={"false"}
                                                                                onChange={(e) => {
                                                                                    setInputdata({ ...inputData, auth_sub_admin_privilege: { ...inputData.auth_sub_admin_privilege, [e.target.name]: e.target.value } })
                                                                                }}
                                                                                checked={inputData && inputData?.auth_sub_admin_privilege && inputData?.auth_sub_admin_privilege[curr.value] === "false"}

                                                                                id="o17"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )

                                                            })
                                                        }
                                                    </Form.Group>
                                                </>
                                            }
                                            <div className="text-center">
                                                <Button
                                                    className="btn_theme mt-4"
                                                    type="submit"
                                                    variant=""
                                                >
                                                    {editSub ? "Update" : "Add +"}
                                                </Button>

                                            </div>
                                        </Form>

                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            <Footer />
        </>
    )
}
export default SubAdmin